if (!Array.prototype.addOrReplace) {
    Array.prototype.addOrReplace = function <T>(predicate: (item: T) => boolean, newItem: T): void {
      const index = this.findIndex(predicate);
      if (index !== -1) {
        this[index] = newItem; // Replace existing item
      } else {
        this.push(newItem); // Add new item
      }
    };
  }